import React from 'react';
import { observer } from "mobx-react";
import { withStore } from "../../hocs";
import { APP_NO_IMG } from "../../const/root";
import { HelperImage } from "../../helper/HelperImage";
import { CircularProgress } from '@mui/material';

// @ts-ignore
@withStore
@observer
export class SearchTopForm extends React.Component {
    formRef: React.RefObject<HTMLFormElement>; // Объявляем поле formRef

    constructor(props: any) {
        super(props);
        this.formRef = React.createRef(); // Создаём реф для формы
        this.state = {
            formWidth: 0, // Храним ширину формы
        };
    }

    componentDidMount() {
        // Устанавливаем начальную ширину формы после её монтирования
        this.updateFormWidth();

        // Добавляем слушатель изменения размеров окна
        window.addEventListener('resize', this.updateFormWidth);
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        // Убираем слушатель при размонтировании
        window.removeEventListener('resize', this.updateFormWidth);
        document.removeEventListener('click', this.handleClickOutside);
    }

    updateFormWidth = () => {
        if (this.formRef.current) {
            const adjustedWidth = this.formRef.current.offsetWidth; // Вычитаем 36px из ширины формы
            this.setState({ formWidth: adjustedWidth }); // Сохраняем результат в состоянии
        }
    };

    // @ts-ignore
    addDefaultSrc = (ev: any) => {
        ev.target.src = APP_NO_IMG;
    };

    handleClickOutside = (event: MouseEvent) => {
        const { store } = this.props as any;
        const searchForm = document.querySelector('.search-form');
        if (searchForm && !searchForm.contains(event.target as Node)) {
            store.componentTopSearchStore.onBlurInput(event);
        }
    };

    render() {
        // @ts-ignore
        const { store } = this.props;
        const {
            onChangeInput,
            onBlurInput,
            onFocus,
            search,
            rows,
            isFocus,
            categories,
            statusSearch,
            idForSearchArray
        } = store.componentTopSearchStore;

        const { formWidth }: any = this.state; // Достаём ширину формы из состояния
        const Width = window.innerWidth;

        return (
            <>
                <div className="search-form">
                    <form
                        ref={this.formRef} // Привязываем реф к форме
                        className="search-form-top"
                        action="/catalog/search"
                        method="get"
                        style={Width > 768 ? { zIndex: 2 } : {}}
                    >
                        <div className="search-form-wrapper">
                            {Width > 768 ? (
                                <img className="search__ico" alt="search_ico.svg" src="/img/ico/search_ico.svg" />
                            ) : null}

                            <input
                                onChange={(e) => onChangeInput(e)}
                                onBlur={(e) => onBlurInput(e)}
                                onFocus={() => onFocus()}
                                name="q"
                                id="search-header-input"
                                value={search}
                                className="search__text"
                                type="text"
                                autoComplete="off"
                                placeholder="Поиск по названию, артикулу, штрихкоду"
                            />
                            {Width > 768 ? (
                                <button className="search__btn" type="submit">Найти</button>
                            ) : (
                                <button className="search__btn" type="submit">
                                    <img style={{ paddingTop: 8 }} alt="search_ico.svg" src="/img/ico/search_ico.svg" />
                                </button>
                            )}
                        </div>
                    </form>
                    {isFocus ? (
                        <a className="search-form__all-result" href={'/catalog/search?q=' + search}>Все результаты поиска</a>
                    ) : null}
                    {isFocus && (
                        <div className="search-form-result" style={{ zIndex: 1, width: `calc(${formWidth}px - 11%)` }}>
                            <ul className="search-form-result_ul" style={{ width: `calc(${formWidth}px - 11%)` }}>
                                <div style={{
                                    maxHeight: '300px',
                                    overflowY: 'auto',
                                    overflowX: 'hidden',

                                }}>
                                    <li className="search-form-result__item_empty" style={{
                                        width: `calc(${formWidth}px - 11%)`, maxHeight: '100px',
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                    }}></li>
                                    {categories && statusSearch === false ? Object.entries(categories).map(([categoryName, categoryIds]: any) => (
                                        <li
                                            className="search-form-result__item"
                                            style={{ height: 45, paddingLeft: '3.5vw', width: `calc(${formWidth}px - 11%)` }}
                                        >
                                            <div>
                                                &#9658;
                                                <a
                                                    key={categoryName}
                                                    style={{ marginTop: 15, textDecoration: 'none', color: 'black', paddingLeft: 10 }}
                                                    href={`/catalog/search_by_category?q=${JSON.stringify(categoryIds)}`}
                                                >
                                                    <span>{categoryName}</span>
                                                    <span style={{ marginLeft: 5, opacity: 0.55 }}>
                                                        около {categoryIds.length} товаров
                                                    </span>
                                                </a>
                                            </div>
                                        </li>
                                    )) : null}

                                </div>

                                {statusSearch ? (
                                    <>
                                        <li className="search-form-result__item" style={{ width: `calc(${formWidth}px - 11%)` }}>
                                            <CircularProgress size="30px" style={{ marginLeft: 30 }} />
                                            <span className="search-form-result__title" style={{ width: `calc(${formWidth}px - 11%)` }}>идет поиск товаров</span>
                                        </li>
                                    </>
                                ) :

                                    <div style={{
                                        maxHeight: '400px',
                                        overflowX: 'hidden',
                                        overflowY: 'auto',
                                    }}>
                                        {
                                            rows.length && statusSearch === false ? rows
                                                .filter((item: any) => idForSearchArray.length === 0 || idForSearchArray.includes(item.id))
                                                .map((item: any) => (
                                                <li className="search-form-result__item" style={{ width: `calc(${formWidth}px - 11%)` }}>
                                                    <a href={'/card/' + item.code} className="search-block-1">
                                                        <img
                                                            className="search-form-result__img"
                                                            onError={this.addDefaultSrc}
                                                            src={HelperImage.getProductImageSrc(item)}
                                                            alt="search-img"
                                                        />
                                                    </a>
                                                    <a href={'/card/' + item.code} className="search-block-2 search-form-result__title">
                                                        {item.name}
                                                    </a>
                                                    <div className="search-form-result__property search-block-3">
                                                        <span className="search-form-result__property-text">Арт. {item?.propsNoFilter?.productCode}</span>
                                                        <span className="search-form-result__property-text">Штрих-код {item?.propsNoFilter?.barcode}</span>
                                                    </div>
                                                </li>
                                            ))
                                                : (
                                                    <li className="search-form-result__item" style={{ width: `calc(${formWidth}px - 11%)` }}>
                                                        <span className="search-form-result__title" style={{ width: `calc(${formWidth}px - 11%)` }}>Нет результатов</span>
                                                    </li>
                                                )
                                        }
                                    </div>

                                }
                            </ul>
                        </div>
                    )}
                </div>
            </>
        );
    }
}
